import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { FiscalYearInfo, FiscalYearInfoAdapter, FiscalYearInfoDTO } from 'src/model/fiscalYearInfo.model';

export interface FiscalYearOptions {
  branchId?: number | number[];
  fiscalYear?: number | number[];
}

@Injectable({
  providedIn: 'root',
})
export class FiscalYearInfoService {
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  getFiscalYearInfos(o?: FiscalYearOptions): Promise<FiscalYearInfo[]> {
    return new Promise<FiscalYearInfo[]>((resolve, reject) => {
      this.api.get<FiscalYearInfoDTO[]>(this.constructApi.getFiscalYearInfos(o?.branchId, o?.fiscalYear)).pipe(
        map(data => data.map(d => FiscalYearInfoAdapter.adapt(d)))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to get annual targets: ', err);
          reject(err);
        }
      })
    })
  }

  postFiscalYearInfo(fiscalYearInfo: Partial<FiscalYearInfo>): Promise<FiscalYearInfo> {
    return new Promise<FiscalYearInfo>((resolve, reject) => {
      this.api.post<FiscalYearInfoDTO>(this.constructApi.getBusinessBranchFiscalYearInfo(fiscalYearInfo.BranchId!, fiscalYearInfo.FiscalYear!), FiscalYearInfoAdapter.toAPIModel(fiscalYearInfo)).subscribe({
        next: response => resolve(FiscalYearInfoAdapter.adapt(response)),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to add annual target: ', err);
          reject(err);
        }
      })
    })
  }

  putFiscalYearInfo(fiscalYearInfo: Partial<FiscalYearInfo>): Promise<FiscalYearInfo> {
    return new Promise<FiscalYearInfo>((resolve, reject) => {
      this.api.put<FiscalYearInfoDTO>(this.constructApi.getBusinessBranchFiscalYearInfo(fiscalYearInfo.BranchId!, fiscalYearInfo.FiscalYear!), FiscalYearInfoAdapter.toAPIModel(fiscalYearInfo)).subscribe({
        next: response => resolve(FiscalYearInfoAdapter.adapt(response)),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to update annual target: ', err);
          reject(err);
        }
      })
    })
  }

  // getBusinessAllFiscalYearInfos(businessId: number): Promise<FiscalYearInfo[]> {
  //   return new Promise<FiscalYearInfo[]>((resolve, reject) => {
  //     this.api.get<FiscalYearInfoDTO[]>(this.constructApi.getBusinessAllFiscalYearInfos(businessId)).pipe(
  //       map(data => data.map(d => FiscalYearInfoAdapter.adapt(d)))
  //     ).subscribe({
  //       next: response => resolve(response),
  //       error: err => {
  //         this.api.handleError(err);
  //         console.error('Failed to get business annual limit: ', err);
  //         reject(err);
  //       }
  //     })
  //   })
  // }

  getBusinessBranchFiscalYearInfo(businessId: number, fiscalYear: number): Promise<FiscalYearInfo> {
    return new Promise<FiscalYearInfo>((resolve, reject) => {
      this.api.get<FiscalYearInfoDTO>(this.constructApi.getBusinessBranchFiscalYearInfo(businessId, fiscalYear)).pipe(
        map(data => FiscalYearInfoAdapter.adapt(data))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          if (err.status !== 404)
            this.api.handleError(err);
          console.error('Failed to get business annual limit: ', err);
          reject(err);
        }
      })
    })
  }

}
